import React from 'react';

const Footer = ({ footer }) => {
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-10">
          <div style={{
            padding: '1rem',
            marginBottom: '2rem',
            textAlign: 'center',
          }}>
            <p style={{ 
              marginBottom: '0.5rem',
              fontSize: '0.9rem',
              color: 'var(--text-color)'
            }}>
              Un producto de:
            </p>
            <img 
              src={footer} 
              alt="Footer" 
              style={{
                maxWidth: '150px',
                height: 'auto'
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
